/* eslint-disable jsx-a11y/click-events-have-key-events */

import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import styles, { optionTheme } from './styles'

const MenuOption = ({ id, label, active, theme, onClick }) => (
  <li id={id} className={cx(styles.option, active && styles.active, optionTheme(theme))} role="menuitem" onClick={onClick}>
    {label}
  </li>
)
MenuOption.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  active: PropTypes.bool,
  theme: PropTypes.string,
  onClick: PropTypes.func,
}

export default MenuOption
